import { render, staticRenderFns } from "./SFSelect.vue?vue&type=template&id=26a28018&lang=pug&"
import script from "./SFSelect.vue?vue&type=script&lang=ts&"
export * from "./SFSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports